
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TKeyValue } from '../../models/common.type';
import { DialogDataModel } from '../../models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  icon!: string;

  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogDataModel) { }

  close(option: string | TKeyValue) {
    this.dialogRef.close((option as TKeyValue)[`key`] ? (option as TKeyValue)[`key`] : option);
  }

}
